import React from 'react';
import { Helmet } from 'react-helmet';

import { supportedLocales } from '../i18n/locales';
import { useI18n } from '../i18n/I18nContext';

const siteUrl = "https://cdo-apps.com";

function absoluteUrl(path) {
  return `${siteUrl}${path}`;
}

function Seo({title, description, path, noindex = false}) {
  const { alternatePathFor, locale } = useI18n();
  const canonicalPath = path ?? alternatePathFor(locale);

  return (
    <Helmet htmlAttributes={{ lang: locale }}>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex" />}
      <link rel="canonical" href={absoluteUrl(canonicalPath)} />
      {supportedLocales.map((supportedLocale) => (
        <link
          key={supportedLocale}
          rel="alternate"
          hrefLang={supportedLocale}
          href={absoluteUrl(alternatePathFor(supportedLocale))}
        />
      ))}
      <link rel="alternate" hrefLang="x-default" href={absoluteUrl(alternatePathFor("fr"))} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={absoluteUrl(canonicalPath)} />
      <meta property="og:locale" content={locale === "fr" ? "fr_FR" : "en_US"} />
    </Helmet>
  );
}

export default Seo;
